import { HttpClient, type HttpResponse } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import moment from "moment";
import { type Observable, ReplaySubject } from "rxjs";
import { map, tap } from "rxjs/operators";
import { environment } from "../../../../environments/environment";
import { createRequestOption } from "../../../shared/util/request-util";
import type { IClientAccessRegistration } from "../model/client-access-registration.model";

@Injectable({
    providedIn: "root",
})
export class ClientAccessRegistrationService {
    private http = inject(HttpClient);

    resourceUrl = environment.apiUrl + "api/client-access/registrations";

    pendingRegistrationsCountSubject = new ReplaySubject<number>(1);
    pendingRegistrationsCount$ =
        this.pendingRegistrationsCountSubject.asObservable();

    findRegistrations(
        req?: any,
    ): Observable<HttpResponse<IClientAccessRegistration[]>> {
        const options = createRequestOption(req);

        return this.http
            .get<
                IClientAccessRegistration[]
            >(this.resourceUrl, { params: options, observe: "response" })
            .pipe(
                map((res) => {
                    this.convertFromServer(res.body);
                    return res;
                }),
            );
    }

    getPendingRegistrationsCount(): Observable<number> {
        return this.http
            .get<number>(`${this.resourceUrl}/pending-count`)
            .pipe(
                tap((count: number) =>
                    this.pendingRegistrationsCountSubject.next(count),
                ),
            );
    }

    approveRegistration(id: number, req?: any) {
        return this.http.post(`${this.resourceUrl}/${id}/approve`, req);
    }

    rejectRegistration(id: number) {
        return this.http.post(`${this.resourceUrl}/${id}/reject`, {});
    }

    private convertFromServer(
        res: IClientAccessRegistration[],
    ): IClientAccessRegistration[] {
        res.forEach((r) => {
            r.createdDate ? moment(r.createdDate) : null;
            r.approvedDate ? moment(r.approvedDate) : null;
            r.lastModifiedDate ? moment(r.lastModifiedDate) : null;
        });
        return res;
    }
}
